module.exports = __webpack_public_path__ + "images/Pencil_hover.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/Pencil_hover.png
// module id = 173
// module chunks = 0 1